import { type TAudioSuggestions as TApiAudioSuggestions } from '@core/api'

import { type TAudioSuggestions } from '@core/models'

import { convertAudioSimple } from './convertAudioSimple'
import { convertCollectionSimple } from './convertCollectionSimple'

export const convertAudioSuggestions = (
    apiAudioSuggestions: TApiAudioSuggestions,
): TAudioSuggestions => {
    const { author, collections, others } = apiAudioSuggestions

    return {
        author: author.map(convertAudioSimple),
        others: others.map(convertAudioSimple),
        collections: collections.map(convertCollectionSimple),
    }
}
